<template>
  <div :class="classObject" :style="{ height: height }">
    <template v-if="data.length">
      <div v-for="(item, index) in data" :key="`${item?.id}-${index}`" @click="elMenuItemClick(item, index)"
        class="content" :class="{ contentActive: activeIndex == index }">
        <div class="name" :title="item.name">{{ item.name }}</div>
        <div class="content-icon">
          <span class="circle"
            :class="{ active: item.status === 'active', inactive: item.status === 'offline', alarm: item.status === 'alarm' }"></span>
        </div>
      </div>
    </template>
    <el-empty description="无数据" v-else></el-empty>
  </div>
</template>

<script>
const classNames = require('classnames')
export default {
  name: "StationListWithCircle",
  props: {
    className: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      required: false,
      default: 'auto'
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    activeIndex: {
      type: Number,
      required: false,
      default: 0
    },

  },
  computed: {
    classObject: function () {
      return classNames({
        'stationListWithCircle': true,
        [this.className]: !!this.className,
      })
    }
  },
  methods: {
    elMenuItemClick(item, index) {
      this.$emit('click', { item, index });
    }
  }
}
</script>

<style scoped lang="scss">
$colorActive: #28CCCB;
$colorNotActive: #999999;
$colorAlarm: #EC5453;
$colorMain: #28CCCB;

.stationListWithCircle {
  overflow: auto;

  .content {
    @include setFlexAround;
    background-color: #fff;
    height: 30px;
    padding: 10px;
    cursor: pointer;

    .name {
      color: #333;
      width: calc(100% - 25px);
      @include setEllipsis
    }

    &-icon {
      width: 20px;

      .circle {
        display: inline-block;
        height: 12px;
        width: 12px;
        border-radius: 6px;
        background-color: $colorNotActive;
      }

      .active {
        background-color: $colorActive;
      }

      .inactive {
        background-color: $colorNotActive;
      }

      .alarm {
        background-color: $colorAlarm;
      }
    }
  }

  .contentActive {
    .name {
      color: $colorActive;
    }
  }

  .content:hover {
    background-color: #eafafa;

    .name {
      color: $colorActive;
    }
  }

  /*定义滚动条轨道*/
  ::-webkit-scrollbar-track {
    background-color: #FFFFFF;
    -webkit-box-shadow: inset 0 0 0px #FFFFFF;
  }

  /*定义滚动条高宽及背景*/
  ::-webkit-scrollbar {
    background-color: #FFFFFF;
  }

  /*定义滚动条*/
  ::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  :hover::-webkit-scrollbar-thumb {
    background-color: #F7F7F7;
  }
}
</style>
